import {
  GET_ORG_ACCOUNTS,
  GET_ORG_ACCOUNTS_SUCCESS,
  GET_ORG_ACCOUNTS_FAILURE,
  GET_ORG_USERS_SUCCESS,
  GET_ORG_SUCCESS,
  UPDATE_ORG_ACCOUNT,
  UPDATE_ORG_ACCOUNT_SUCCESS,
  UPDATE_ORG_ACCOUNT_FAILURE,
  ADD_ORG_ACCOUNT,
  ADD_ORG_ACCOUNT_SUCCESS,
  ADD_ORG_ACCOUNT_FAILURE,
  DELETE_ORG_ACCOUNT,
  DELETE_ORG_ACCOUNT_SUCCESS,
  DELETE_ORG_ACCOUNT_FAILURE,
  DELETE_ORG_USER,
  DELETE_ORG_USER_SUCCESS,
  DELETE_ORG_USER_FAILURE,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
  GET_ORG_ACCOUNT_WORKLOADS,
  GET_ORG_ACCOUNT_WORKLOADS_SUCCESS,
  GET_ORG_ACCOUNT_WORKLOADS_FAILURE,
  UPDATE_ORG_ACCOUNT_WORKLOAD,
  UPDATE_ORG_ACCOUNT_WORKLOAD_SUCCESS,
  UPDATE_ORG_ACCOUNT_WORKLOAD_FAILURE,
  GET_SCAN_SCHEDULES,
  GET_SCAN_SCHEDULES_SUCCESS,
  GET_SCAN_SCHEDULES_FAILURE,
  UPDATE_SCAN_SCHEDULE_FREQUENCY,
  UPDATE_SCAN_SCHEDULE_FREQUENCY_SUCCESS,
  UPDATE_SCAN_SCHEDULE_FREQUENCY_FAILURE,
  POST_FEATURE_CONFIGURATION,
  POST_FEATURE_CONFIGURATION_SUCCESS,
  POST_FEATURE_CONFIGURATION_FAILURE,
} from "./actionTypes";

const initialState = {
  orgAccounts: null,
  orgUsers: null,
  organization: null,
  
  getOrgAccountsError: null,
  isGettingOrgAccounts: false,
  getOrgAccountsMessage: null,

  updateOrgAccountError: null,
  isUpdatingOrgAccount: false,
  updateOrgAccountMessage: null,

  deleteOrgAccountError: null,
  isDeletingOrgAccount: false,
  deleteOrgAccountMessage: null,

  deleteOrgUserError: null,
  isDeletingOrgUser: false,
  deleteOrgUserMessage: null,

  // Workload states
  workloads: null,
  isGettingWorkloads: false,
  getWorkloadsError: null,
  getWorkloadsMessage: null,

  // Update workload states
  isUpdatingWorkload: false,
  updateWorkloadError: null,
  updateWorkloadMessage: null,

  // Scan schedules states
  scanSchedules: null,
  isGettingScanSchedules: false,
  getScanSchedulesError: null,
  getScanSchedulesMessage: null,

  // Update scan schedule states
  isUpdatingScanSchedule: false,
  updateScanScheduleError: null,
  updateScanScheduleMessage: null,

  // Feature configuration states
  isPostingFeatureConfiguration: false,
  postFeatureConfigurationError: null,
  postFeatureConfigurationMessage: null,
};

const orgAccount = (state = initialState, action) => {
  console.log("reducer, action Type :: ", action.type);
  switch (action.type) {
    case GET_ORG_ACCOUNTS:
      console.log("reducer -> GET_ORG_ACCOUNTS called ");
      state = {
        ...state,
        isGettingOrgAccounts: true,
        getOrgAccountsError: null,
        // Keep existing accounts during refresh so the modal limit does not flash to default
        getOrgAccountsMessage: null,
        orgCode: action.payload.orgCode,
      };
      break;
    case GET_ORG_ACCOUNTS_SUCCESS:
      console.log(
        "reducer -> GET_ORG_ACCOUNTS_SUCCESS called with Organization Accounts :: ",
        action.payload.orgAccounts
      );
      state = {
        ...state,
        isGettingOrgAccounts: false,
        getOrgAccountsError: null,
        orgAccounts: action.payload.orgAccounts,
        getOrgAccountsMessage: "Organization Accounts retrieved successfully!",
      };
      break;
    case GET_ORG_ACCOUNTS_FAILURE:
      console.log(
        "reducer -> GET_ORG_ACCOUNTS_FAILURE called with error :: ",
        action.payload.error
      );
      state = {
        ...state,
        isGettingOrgAccounts: false,
        getOrgAccountsError: action.payload.error,
        orgAccounts: null,
      };
      break;
    case GET_ORG_USERS_SUCCESS:
      console.log(
        "reducer -> GET_ORG_USERS_SUCCESS called with orgUsers: " +
          action.payload.orgUsers
      );
      state = {
        ...state,
        orgUsers: action.payload.orgUsers,
      };
      break;
    case GET_ORG_SUCCESS:
      console.log("reducer -> GET_ORG_SUCCESS called with organization: "+ action.payload.organization)
      state = {
        ...state,
        organization: action.payload.organization
      };
      break;
    case UPDATE_ORG_ACCOUNT:
      console.log(
        "reducer -> UPDATE_ORG_ACCOUNT called with org Account: ",
        action.payload.orgAccount
      );
      state = {
        ...state,
        isUpdatingOrgAccount: true,
        updateOrgAccountError: null,
        updateOrgAccountPayload: action.payload.updateOrgAccountPayload,
        // orgAccountCode: action.payload.orgAccountCode,
        // subscription: action.payload.subscription,
        updateOrgAccountMessage: null,
      };
      break;
    case UPDATE_ORG_ACCOUNT_SUCCESS:
      console.log(
        "reducer -> UPDATE_ORG_ACCOUNT_SUCCESS called with org Account: "
      );
      state = {
        ...state,
        isUpdatingOrgAccount: false,
        updateOrgAccountError: null,
        updateOrgAccountMessage: "Organization Account updated successfully!",
      };
      break;
    case UPDATE_ORG_ACCOUNT_FAILURE:
      console.log(
        "reducer -> UPDATE_ORG_ACCOUNT_FAILURE called with error: ",
        action.payload.error
      );
      state = {
        ...state,
        isUpdatingOrgAccount: false,
        updateOrgAccountError: action.payload.error,
        orgAccount: null,
      };
      break;
      case ADD_ORG_ACCOUNT:
        console.log(
          "reducer -> ADD_ORG_ACCOUNT called with org Account: ",
          action.payload.addOrgAccountPayload
        );
        state = {
          ...state,
          isAddingOrgAccount: true,
          addOrgAccountError: null,
          addOrgAccountPayload: action.payload.addOrgAccountPayload,
          addOrgAccountMessage: null,
        };
        break;
      case ADD_ORG_ACCOUNT_SUCCESS:
        console.log(
          "reducer -> ADD_ORG_ACCOUNT_SUCCESS called with org Account: "
        );
        state = {
          ...state,
          isAddingOrgAccount: false,
          addOrgAccountError: null,
          addOrgAccountMessage: "Organization Account added successfully!",
        };
        break;
      case ADD_ORG_ACCOUNT_FAILURE:
        console.log(
          "reducer -> ADD_ORG_ACCOUNT_FAILURE called with error: ",
          action.payload.error
        );
        state = {
          ...state,
          isAddingOrgAccount: false,
          addOrgAccountError: action.payload.error,
          orgAccount: null,
        };
        break;
    case DELETE_ORG_ACCOUNT:
      console.log(
        "reducer -> DELETE_ORG_ACCOUNT called with organization account code: ",
        action.payload.orgAccountCode
      );
      state = {
        ...state,
        isDeletingOrgAccount: true,
        deleteOrgAccountError: null,
        orgAccountCode: action.payload.orgAccountCode,
        orgCode: action.payload.orgCode,
        deleteOrgAccountMessage: null,
      };
      break;
    case DELETE_ORG_ACCOUNT_SUCCESS:
      console.log("reducer -> DELETE_ORG_ACCOUNT_SUCCESS called ");
      state = {
        ...state,
        isDeletingOrgAccount: false,
        deleteOrganizationError: null,
        deleteOrgAccountMessage: "Organization Account deleted successfully!",
      };
      break;
    case DELETE_ORG_ACCOUNT_FAILURE:
      console.log(
        "reducer -> DELETE_ORG_ACCOUNT_FAILURE called with error: ",
        action.payload.error
      );
      state = {
        ...state,
        isDeletingOrgAccount: false,
        deleteOrgAccountError: action.payload.error,
        orgCode: null,
        orgAccountCode: null,
      };
      break;
    case DELETE_ORG_USER:
      console.log(
        "reducer -> DELETE_ORG_USER called with username : ",
        action.payload.email
      );
      state = {
        ...state,
        isDeletingOrgUser: true,
        deleteOrgUserError: null,
        orgCode: action.payload.orgCode,
        username: action.payload.email,
        deleteOrgUserMessage: null,
      };
      break;
    case DELETE_ORG_USER_SUCCESS:
      console.log("reducer -> DELETE_ORG_USER_SUCCESS called ");
      state = {
        ...state,
        isDeletingOrgUser: false,
        deleteOrgUserError: null,
        deleteOrgUserMessage: "Organization User deleted successfully!",
      };
      break;
    case DELETE_ORG_USER_FAILURE:
      console.log(
        "reducer -> DELETE_ORG_USER_FAILURE called with error: ",
        action.payload.error
      );
      state = {
        ...state,
        isDeletingOrgUser: false,
        deleteOrgUserError: action.payload.error,
        orgCode: null,
        username: null,
      };
      break;
    case CLEAR_ALL_MESSAGES_SUCCESS:
      state = {
        ...state,
        getOrgAccountsMessage: null,
        updateOrgAccountMessage: null,
        deleteOrgAccountMessage: null,
        deleteOrgUserMessage: null,

        getOrgAccountsError: null,
        updateOrgAccountError: null,
        deleteOrgAccountError: null,
        postFeatureConfigurationError: null,
        postFeatureConfigurationMessage: null,
        deleteOrgUserError: null,

        // Clear scan schedule messages
        getScanSchedulesError: null,
        getScanSchedulesMessage: null,
        updateScanScheduleError: null,
        updateScanScheduleMessage: null,
        
        // Clear feature configuration messages
        postFeatureConfigurationError: null,
        postFeatureConfigurationMessage: null,
      };
      break;
    case CLEAR_SUCCESS_MESSAGES_SUCCESS:
      state = {
        ...state,
        getOrgAccountsMessage: null,
        updateOrgAccountMessage: null,
        deleteOrgAccountMessage: null,
        deleteOrgUserMessage: null,
      };
      break;
    case CLEAR_FAILURE_MESSAGES_SUCCESS:
      state = {
        ...state,
        getOrgAccountsError: null,
        updateOrgAccountError: null,
        deleteOrgAccountError: null,
        deleteOrgUserError: null,
      };
      break;
    case GET_ORG_ACCOUNT_WORKLOADS:
      console.log("reducer -> GET_ORG_ACCOUNT_WORKLOADS called with accountNumber: ", action.payload.accountNumber);
      state = {
        ...state,
        isGettingWorkloads: true,
        getWorkloadsError: null,
        workloads: null,
        getWorkloadsMessage: null,
        accountNumber: action.payload.accountNumber,
      };
      break;
    case GET_ORG_ACCOUNT_WORKLOADS_SUCCESS:
      console.log("reducer -> GET_ORG_ACCOUNT_WORKLOADS_SUCCESS called with workloads: ", action.payload.workloads);
      state = {
        ...state,
        isGettingWorkloads: false,
        getWorkloadsError: null,
        workloads: action.payload.workloads,
        getWorkloadsMessage: "Workloads retrieved successfully!",
      };
      break;
    case GET_ORG_ACCOUNT_WORKLOADS_FAILURE:
      console.log("reducer -> GET_ORG_ACCOUNT_WORKLOADS_FAILURE called with error: ", action.payload);
      state = {
        ...state,
        isGettingWorkloads: false,
        getWorkloadsError: action.payload,
        workloads: null,
      };
      break;
    case UPDATE_ORG_ACCOUNT_WORKLOAD:
      console.log("reducer -> UPDATE_ORG_ACCOUNT_WORKLOAD called with payload: ", action.payload);
      state = {
        ...state,
        isUpdatingWorkload: true,
        updateWorkloadError: null,
        updateWorkloadMessage: null,
      };
      break;
    case UPDATE_ORG_ACCOUNT_WORKLOAD_SUCCESS: {
      console.log("reducer -> UPDATE_ORG_ACCOUNT_WORKLOAD_SUCCESS called", action.payload);
      const responseData = action.payload.responseData;
      console.log("responseData:", responseData);
      console.log("responseData.workloadId:", responseData?.workloadId);
      console.log("responseData.newLimit:", responseData?.newLimit);
      
      const updatedWorkloads = state.workloads ? state.workloads.map(workload => {
        if (workload["Workload ID"] === responseData?.workloadId) {
          return {
            ...workload,
            automationRunLimitPerDay: responseData?.newLimit
          };
        }
        return workload;
      }) : null;
      
      state = {
        ...state,
        isUpdatingWorkload: false,
        updateWorkloadError: null,
        updateWorkloadMessage: responseData.message || "Workload updated successfully!",
        workloads: updatedWorkloads,
      };
      break;
    }
    case UPDATE_ORG_ACCOUNT_WORKLOAD_FAILURE:
      console.log("reducer -> UPDATE_ORG_ACCOUNT_WORKLOAD_FAILURE called with error: ", action.payload.error);
      state = {
        ...state,
        isUpdatingWorkload: false,
        updateWorkloadError: action.payload.error,
        updateWorkloadMessage: null,
      };
      break;
    case GET_SCAN_SCHEDULES:
      console.log("reducer -> GET_SCAN_SCHEDULES called with orgCode: ", action.payload.orgCode, "accountCode: ", action.payload.accountCode);
      state = {
        ...state,
        isGettingScanSchedules: true,
        getScanSchedulesError: null,
        getScanSchedulesMessage: null,
        updateScanScheduleError: null,
        updateScanScheduleMessage: null,
        // Keep existing schedules during refresh so saved fields (e.g. auditScanLimit) are not wiped mid-request
        orgCode: action.payload.orgCode,
        accountCode: action.payload.accountCode,
      };
      break;
    case GET_SCAN_SCHEDULES_SUCCESS: {
      console.log("reducer -> GET_SCAN_SCHEDULES_SUCCESS called with schedules: ", action.payload.schedules);
      const incomingSchedules = action.payload.schedules || [];
      const previousSchedules = state.scanSchedules;
      const mergedSchedules = incomingSchedules.map((schedule) => {
        const previous = previousSchedules?.find((s) => s.scheduleId === schedule.scheduleId);
        const auditScanLimit =
          schedule.auditScanLimit ??
          schedule.audit_scan_limit ??
          previous?.auditScanLimit;
        if (auditScanLimit === undefined || auditScanLimit === null) {
          return schedule;
        }
        return { ...schedule, auditScanLimit };
      });
      state = {
        ...state,
        isGettingScanSchedules: false,
        getScanSchedulesError: null,
        scanSchedules: mergedSchedules,
        getScanSchedulesMessage: "Scan schedules retrieved successfully!",
      };
      break;
    }
    case GET_SCAN_SCHEDULES_FAILURE:
      console.log("reducer -> GET_SCAN_SCHEDULES_FAILURE called with error: ", action.payload);
      state = {
        ...state,
        isGettingScanSchedules: false,
        getScanSchedulesError: action.payload,
        scanSchedules: null,
      };
      break;
    case UPDATE_SCAN_SCHEDULE_FREQUENCY:
      console.log("reducer -> UPDATE_SCAN_SCHEDULE_FREQUENCY called with payload: ", action.payload);
      state = {
        ...state,
        isUpdatingScanSchedule: true,
        updateScanScheduleError: null,
        updateScanScheduleMessage: null,
      };
      break;
    case UPDATE_SCAN_SCHEDULE_FREQUENCY_SUCCESS: {
      console.log("reducer -> UPDATE_SCAN_SCHEDULE_FREQUENCY_SUCCESS called", action.payload);
      const responseData = action.payload.responseData;
      const scheduleId = responseData?.schedule_id || action.payload.schedule_id;
      const newFrequency = responseData?.frequency || action.payload.frequency;
      const newStatus = responseData?.status || action.payload.status;
      const newAuditScanLimit = responseData?.auditScanLimit ?? action.payload.auditScanLimit;
      const message = responseData?.message || "Scan schedule updated successfully!";
      
      const updatedSchedules = state.scanSchedules && scheduleId
        ? state.scanSchedules.map(schedule => {
            if (schedule.scheduleId === scheduleId) {
              return {
                ...schedule,
                ...(newFrequency && { frequency: newFrequency }),
                ...(newStatus && { status: newStatus }),
                ...(newAuditScanLimit !== undefined && newAuditScanLimit !== null && { auditScanLimit: newAuditScanLimit }),
              };
            }
            return schedule;
          })
        : state.scanSchedules;
      
      state = {
        ...state,
        isUpdatingScanSchedule: false,
        updateScanScheduleError: null,
        updateScanScheduleMessage: message,
        scanSchedules: updatedSchedules,
      };
      break;
    }
    case UPDATE_SCAN_SCHEDULE_FREQUENCY_FAILURE:
      console.log("reducer -> UPDATE_SCAN_SCHEDULE_FREQUENCY_FAILURE called with error: ", action.payload.error);
      state = {
        ...state,
        isUpdatingScanSchedule: false,
        updateScanScheduleError: action.payload.error,
        updateScanScheduleMessage: null,
      };
      break;
    case POST_FEATURE_CONFIGURATION:
      console.log("reducer -> POST_FEATURE_CONFIGURATION called");
      state = {
        ...state,
        isPostingFeatureConfiguration: true,
        postFeatureConfigurationError: null,
        postFeatureConfigurationMessage: null,
      };
      break;
    case POST_FEATURE_CONFIGURATION_SUCCESS: {
      console.log("reducer -> POST_FEATURE_CONFIGURATION_SUCCESS called");
      const responseData = action.payload.responseData || {};
      // Handle both string response and object with message property
      let message;
      if (typeof responseData === 'string') {
        message = responseData;
      } else if (responseData?.message) {
        message = responseData.message;
      } else {
        message = "Feature configuration submitted successfully!";
      }
      state = {
        ...state,
        isPostingFeatureConfiguration: false,
        postFeatureConfigurationError: null,
        postFeatureConfigurationMessage: message,
      };
      break;
    }
    case POST_FEATURE_CONFIGURATION_FAILURE:
      console.log("reducer -> POST_FEATURE_CONFIGURATION_FAILURE called with error: ", action.payload.error);
      state = {
        ...state,
        isPostingFeatureConfiguration: false,
        postFeatureConfigurationError: action.payload.error,
        postFeatureConfigurationMessage: null,
      };
      break;
    default:
      return state;
  }
  return state;
}

export default orgAccount;